/**
 * A word diff drawn inline (docs/ux/workspace.md): deletions struck in the
 * error tone, insertions underlined in the success tone, each with a hidden
 * word so the change is never colour alone.
 */

import { cn } from 'cn';
import type { DiffOp } from '@/app/types';

export function WordDiff({ ops, className }: { ops: DiffOp[]; className?: string }) {
  return (
    <span className={cn('whitespace-pre-wrap', className)}>
      {ops.map((op, i) => {
        if (op.kind === 'equal') return <span key={i}>{op.text}</span>;
        if (op.kind === 'delete') {
          return (
            <del key={i} className="text-beam-error decoration-beam-error line-through decoration-1">
              <span className="sr-only">removed: </span>{op.text}
            </del>
          );
        }
        return (
          <ins key={i} className="text-beam-success decoration-beam-success underline decoration-2 underline-offset-2 no-underline-reset">
            <span className="sr-only">added: </span>{op.text}
          </ins>
        );
      })}
    </span>
  );
}

/** "disk -> disc" style summary for row headings and accessible names, without arrows in prose: "disk becomes disc". */
export function changeSummary(before: string, after: string): string {
  const b = before.trim() === '' ? '(nothing)' : before.trim();
  const a = after.trim() === '' ? '(removed)' : after.trim();
  return `${b} becomes ${a}`;
}
